import { ITaxDashboardByStoreItem, ITaxDashboardByStoreParams, ITaxDashboardByUFItem, ITaxDashboardByUFParams, ITaxDashboardItem, ITaxDashboardParams } from "@/@types/tax-dashboard";
import { Tags } from "@/enum/tags";
import { apiSlice } from "./http";

export const taxDashboardService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTaxDashboard: builder.query<ITaxDashboardItem[], ITaxDashboardParams>({
      query: ({ startDate, endDate, stores, groupByMonth }) => {
        const params = new URLSearchParams();
        
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);
        if (stores?.length) params.append('stores', stores.join(','));
        if (groupByMonth) params.append('groupByMonth', groupByMonth.toString());

        return {
          url: `/tax-dashboard?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.TAX_DASHBOARD],
    }),
    getTaxDashboardByUF: builder.query<ITaxDashboardByUFItem[], ITaxDashboardByUFParams>({
      query: ({ startDate, endDate }) => {
        const params = new URLSearchParams();
        
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);

        return {
          url: `/tax-dashboard/by-state?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.TAX_DASHBOARD],
    }),
    getTaxDashboardByStore: builder.query<ITaxDashboardByStoreItem[], ITaxDashboardByStoreParams>({
      query: ({ startDate, endDate }) => {
        const params = new URLSearchParams();
        
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);

        return {
          url: `/tax-dashboard/by-store?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.TAX_DASHBOARD],
    })
  }),
});

export const { 
  useLazyGetTaxDashboardQuery, 
  useLazyGetTaxDashboardByUFQuery,
  useLazyGetTaxDashboardByStoreQuery
} = taxDashboardService; 